import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AppsService } from '@app/shared/services/apps/apps.service';

@Component({
  standalone: false,
  selector: 'sbnb-apps-subnav',
  styleUrls: ['./apps-subnav.component.scss'],
  template: `
    <nav class="apps-subnav" fxLayout="column" fxLayoutGap="32px">
      <div *ngIf="integrationsCategories$ | async as categories">
        <h4 class="not-clickable" fxLayoutAlign="start center" fxLayoutGap="8px">
          <sbnb-icon icon="check" class="text-smoke-darker"></sbnb-icon>
          <span>Integrations</span>
        </h4>
        <div fxLayout="column" fxLayoutGap="16px" style="padding-left: 26px">
          <a [routerLink]="['./']" [queryParams]="{ categories: [] }" routerLinkActive="linkActive">All</a>
          <a *ngFor="let category of categories" [routerLink]="['./']" [queryParams]="{ categories: category }">
            {{ category }}
          </a>
        </div>
      </div>

      <div *ngIf="tools$ | async as tools">
        <h4 class="not-clickable" fxLayoutAlign="start center" fxLayoutGap="8px">
          <sbnb-icon icon="cog" class="text-smoke-darker"></sbnb-icon>
          <span>Tools</span>
        </h4>
        <div *ngIf="tools.length > 0" fxLayout="column" fxLayoutGap="16px" style="padding-left: 26px">
          <a *ngFor="let tool of tools" [routerLink]="'/apps/' + tool.link">{{ tool.title }}</a>
        </div>
      </div>
    </nav>
  `,
})
export class AppsSubnavComponent {
  integrations$ = this.appService.integrations$;
  integrationsCategories$ = this.appService.integrationsCategories$;

  tools$ = this.appService.tools$;

  constructor(
    private appService: AppsService,
    private router: Router
  ) { }
}
